import React from 'react';
import { Alert } from '@mui/material';

export default function RunHistorySaveWarning() {
  return (
    <Alert severity="warning" sx={{ mb: 1 }}>
      This result was computed, but saving it to run history could not be confirmed.
      Export any results you need before switching runs, leaving this page, or reloading.
    </Alert>
  );
}
